export enum ETipoConteudo {
    Pagina = 1,
    LandingPage = 2,
    Blog = 3,
}
